import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { FormItemTypes } from '@bimser/core';
import { List } from 'immutable';

export function setPanelChildren(
	item: LayoutCreatorEntities.LayoutItem,
	allItems: LayoutCreatorEntities.NormalizedLayoutStructureItems
): LayoutCreatorEntities.NormalizedLayoutItems {
	let normalizedItems = LayoutCreatorEntities.NormalizedLayoutItemsFactory();

	if (
		!(
			item.type === FormItemTypes.EControlTypes.ScrollView ||
			item.type === FormItemTypes.EControlTypes.Panel ||
			item.type === FormItemTypes.EControlTypes.Tab ||
			item.type === FormItemTypes.EControlTypes.Tabs ||
			item.type === FormItemTypes.EControlTypes.InputGroup ||
			item.type === FormItemTypes.EControlTypes.Collapse
		) &&
		!item.items?.count()
	) {
		return normalizedItems;
	}
	const loadChildren = (items: string[], isRootItem?: boolean) => {
		if (isRootItem) {
			normalizedItems = normalizedItems.set('result', List(items));
		}
		items.forEach(id => {
			const childItem = allItems.entities.items.get(id);
			if (childItem) {
				normalizedItems = normalizedItems.setIn(['entities', 'items', id], childItem);
				if (childItem.items?.count()) {
					loadChildren(childItem.items.toJS());
				}
			}
		});
	};
	loadChildren(item.items.toJS() as string[], true);
	return normalizedItems;
}
